import Pvolve from '@pvolve/sdk';
import { isEmpty } from 'lodash';

export async function getVideoSrc(id, type) {
    const video = await Pvolve.api.content.videoSource(type, id, 'video');
    return video;
}

export async function getPreviewVideoSrc(id, type) {
    const data = await Pvolve.api.content.publicVideoSource(type, id, 'previewVideo');
    return data;
}

export async function getThumbnailSrc(id, type) {
    return await Pvolve.api.content.imageSource(type, id, 'video');
}

export async function getStoryboard(id, type, entitled) {
    const tokenType = entitled ? undefined : 'none';
    const contentType = entitled ? 'video' : 'previewVideo';
    return await Pvolve.api.content.storyboard(type, id, contentType, tokenType);
}

export async function getMuxVideoSource(id, type, fieldName) {
    if (fieldName === 'video') {
        return await getVideoSrc(id, type);
    } else if (fieldName === 'previewVideo') {
        return await getPreviewVideoSrc(id, type);
    }
}

// FIXME: Remove this when P&F is refactored
export async function getQuestionnaire(id) {
    return await Pvolve.api.content.findById('questionnaires', id);
}

export async function getDynamicContent(filter, contains) {
    return await Pvolve.api.content.findByFilterContains('dynamic_content', filter, contains);
}

export async function getFeaturePhaseAndFunction(email) {
    return await Pvolve.api.featureFlag.featureFlagByName(
        ['phaseAndFunctionBeta', 'phaseAndFunctionSeries'],
        'web',
        email
    );
}

export async function getWorkoutsStatsById(id) {
    const response = await Pvolve.api.statsV2.workouts(id);
    return response?.data;
}

export async function getProductDetails(sku) {
    const response = await Pvolve.api.subscription.listSubscriptionProducts(sku);
    return response;
}

export async function brazeHandleNewsletter(email, date) {
    let usersResponse = await Pvolve.api.braze.getUsers(email);
    const userList = await usersResponse;

    let userAlias = {};
    let user = userList.users.find((item) => {
        if (item.user_aliases.length > 0) {
            userAlias = item.user_aliases.find(
                (alias) => alias.alias_name === email && alias.alias_label === 'email_address'
            );
        }

        return (
            (item.email === email && !isEmpty(item.external_id) && item.external_id !== email) ||
            !!userAlias
        );
    });

    if (!!user) {
        const { message } = await Pvolve.api.braze.trackUserEvent(user, userAlias, date);
        return message;
    }

    userAlias = { alias_name: email, alias_label: 'email_address' };
    let userAliases = [userAlias];

    const { message } = await Pvolve.api.braze.createAliasAccount(userAliases);
    if (message === 'success') {
        const { message } = await Pvolve.api.braze.trackUserEvent({ email }, userAlias, date);
        return message;
    }

    return 'failed';
}
